import { OmrHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteThirdPartyInvoiceData = (thirdPartyClubRegistrationPersonOfferingId, state, setState) => {
  if (state.isSaving !== true && thirdPartyClubRegistrationPersonOfferingId > 0 && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const thirdPartyClubRegistrationPersonOfferingIdForUrl = thirdPartyClubRegistrationPersonOfferingId ? encodeURIComponent(thirdPartyClubRegistrationPersonOfferingId) : 'NaN';
    const url = `/MemberRegistration/ThirdPartyClubRegistrationPersonOffering/${thirdPartyClubRegistrationPersonOfferingIdForUrl}`;
    OmrHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteThirdPartyInvoiceData;